import { makeActionCreator } from '../../config/store/utils'
import { unsubscribe } from '../../services/mailing'

export const UNSUBSCRIBE_GENERIC = 'UNSUBSCRIBE_GENERIC'
export const UNSUBSCRIBE_GENERIC_ERROR = 'UNSUBSCRIBE_GENERIC_ERROR'
export const UNSUBSCRIBE_GENERIC_SUCCESS = 'UNSUBSCRIBE_GENERIC_SUCCESS'
export const onUnsubscribeGeneric = makeActionCreator(UNSUBSCRIBE_GENERIC)
export const onUnsubscribeGenericError = makeActionCreator(UNSUBSCRIBE_GENERIC_ERROR, 'payload')
export const onUnsubscribeGenericSuccess = makeActionCreator(UNSUBSCRIBE_GENERIC_SUCCESS)
export const onUnsubscribeGenericThunk =
  ({ qs }) =>
  async dispatch => {
    dispatch(onUnsubscribeGeneric())

    try {
      await unsubscribe({ actionType: UNSUBSCRIBE_GENERIC, qs: encodeURIComponent(qs) })

      return dispatch(onUnsubscribeGenericSuccess())
    } catch (error) {
      return dispatch(onUnsubscribeGenericError({ error }))
    }
  }
